import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/classificationByParamses/form'
import { api, actionCreators } from 'store/modules/classificationByParamses'

const metadata = {
  icon: 'cogs',
  page: 'classificationByParamses',
  dialogSize: dialogSizes.MD
}

export default createDetailDialog({ metadata, api, actionCreators, Form })
